import { PackagingQuantization, PackagingRuntime } from './enums.js';
/** TOPS au-delà desquels on privilégie FP16 sur INT8 : le budget de calcul rend la quantification
 *  entière superflue, et FP16 préserve la précision sans coûter la latence. */
const HIGH_TOPS_THRESHOLD = 50;
/** Latence cible (ms) en deçà de laquelle un runtime générique gagne à quantifier en INT8. */
const TIGHT_LATENCY_MS = 40;
export function derivePackagingRecommendation(compute) {
    // On raisonne sur le SoC et l'accélérateur réunis, en minuscules : « Jetson Orin » comme
    // « Ampere 1024 c. » doivent l'un et l'autre pouvoir déclencher la famille NVIDIA.
    const haystack = `${compute.soc ?? ''} ${compute.accelerator ?? ''}`.toLowerCase();
    if (/jetson|orin|xavier|nvidia|cuda|tensorrt/.test(haystack)) {
        // Budget élevé : FP16 tient la latence sans le coût de calibration d'INT8.
        const highTops = compute.tops != null && compute.tops >= HIGH_TOPS_THRESHOLD;
        return {
            runtime: PackagingRuntime.TENSORRT,
            quantization: highTops ? PackagingQuantization.FP16 : PackagingQuantization.INT8,
            rationale: highTops
                ? 'Accélérateur NVIDIA/Jetson à fort budget → TensorRT FP16 (précision préservée).'
                : 'Accélérateur NVIDIA/Jetson → TensorRT INT8 (latence embarquée).',
        };
    }
    if (/coral|edge tpu|edgetpu|hailo/.test(haystack)) {
        return {
            runtime: PackagingRuntime.TFLITE,
            quantization: PackagingQuantization.INT8,
            rationale: 'Edge TPU (Coral) / Hailo → TFLite INT8 (exigé par l’accélérateur).',
        };
    }
    // CPU / SoC générique / inconnu : ONNX est le repli universel. INT8 seulement si la latence
    // cible est serrée — sinon on reste en pleine précision, plus fidèle.
    const tightLatency = compute.latencyMs != null && compute.latencyMs <= TIGHT_LATENCY_MS;
    return {
        runtime: PackagingRuntime.ONNX,
        quantization: tightLatency ? PackagingQuantization.INT8 : PackagingQuantization.NONE,
        rationale: tightLatency
            ? 'CPU / SoC générique à latence serrée → ONNX INT8 (repli universel, allégé).'
            : 'CPU / SoC générique → ONNX pleine précision (repli universel).',
    };
}
//# sourceMappingURL=packaging.js.map